import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/paperclip-attachment.svg'
import _imports_1 from '@/assets/edit-plus-icon.svg'


const _hoisted_1 = { class: "w-full mt-[30px] h-[calc(100vh-110px)] pl-3 sm:pl-0 overflow-y-auto" }
const _hoisted_2 = { class: "max-w-[1156px] mx-auto" }
const _hoisted_3 = { class: "flex items-center gap-2 pb-[9px]" }
const _hoisted_4 = { class: "flex items-center gap-[2px]" }
const _hoisted_5 = { class: "text-xl leading-[26px] tracking-[0.01rem] text-[#616068] font-medium" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-[12.5px]"
}
const _hoisted_7 = { class: "flex-1" }
const _hoisted_8 = { class: "flex items-center justify-between p-3 rounded-primary-radius bg-[#E5E4E2] hover:bg-[#dfdedc] duration-500" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-[14px] tracking-[0.01rem] text-primary-text-color font-medium py-[2px] px-[6px] rounded-primary-radius bg-[#A7A5AE]"
}
const _hoisted_11 = {
  key: 1,
  class: "text-[12px] tracking-[0.01rem] text-white font-semibold py-[2px] px-[6px] rounded-primary-radius bg-[#D97706]",
  title: "Signatures are saved but the PDF was not regenerated. Open the protocol and use Force Regenerate."
}
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex-1" }
const _hoisted_16 = {
  key: 0,
  class: "text-[14px] tracking-[0.01rem] text-primary-text-color font-medium py-[2px] px-[6px] rounded-primary-radius bg-[#A7A5AE]"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_19 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_20 = { class: "mt-3" }

import HeadBlocks from "@/components/Project/Appointment/HeadBlocks.vue";
import IssuesBlock from "@/components/Project/Appointment/IssuesBlock.vue";
import MeisterNoteBlock from "@/components/Project/Appointment/MeisterNoteBlock.vue";
import PrufBerichtModal from "@/components/Project/Appointment/Modal/PrufBerichtModal.vue";
import AbnameProtocolModal from "@/components/Project/Appointment/Modal/AbnameProtocolModal.vue";
import NoteBlock from "@/components/Project/Appointment/NoteBlock.vue";
import client from "@/utils/axios";
import { getStatusByName } from "@/utils/report-status";
import { ref, onMounted } from "vue";
import UpdateAbnahmeProtocolModal from "@/components/Project/Appointment/Modal/UpdateAbnahmeProtocolModal.vue";
import {
  getTerminStatusColor,
  getTerminStatusBorder,
} from "@/utils/status-color";

type Props = {
  termin: any;
  projectName: string;
  isIssuesFeatureFlagActive: boolean;
};

type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TerminVIew',
  props: {
    termin: {},
    projectName: {},
    isIssuesFeatureFlagActive: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any) {

const props = __props;


const prufberichtModalOpen = ref(false);
const abnahmeProtocolModalOpen = ref(false);
const prufberichtReportData = ref<any>(null);
const abnahmeprotokollReportData = ref<any>();
const isSignedDocument = ref(false);

const isUpdateAbnahmeProtocolModal = ref<boolean>(false);

const getPrufberichtReportData = async () => {
  try {
    let resp = await client.get(
      `/termin/${props.termin.id}/prufbericht-report`
    );

    prufberichtReportData.value = resp.data;
  } catch (error: any) {
    console.error(error);
  }
};

const getAbnahmeprotokollReportData = async () => {
  try {
    let resp = await client.get(
      `/termin/${props.termin.id}/abnahmeprotokoll-report`
    );
    abnahmeprotokollReportData.value = resp.data;
  } catch (error: any) {
    console.error(error);
  }
};

const openPrufberichtModal = async () => {
  await getPrufberichtReportData();
  prufberichtModalOpen.value = true;
};
const openAbnahmeprotokollModal = async () => {
  await getAbnahmeprotokollReportData();
  abnahmeProtocolModalOpen.value = true;
};

onMounted(async () => {
  if ([1, 2].includes(props.termin.phase_progress?.phase?.id)) {
    await getPrufberichtReportData();
    await getAbnahmeprotokollReportData();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.termin.name), 1)
        ]),
        _createElementVNode("span", {
          class: "text-xs text-primary-text-color font-medium py-[2px] px-[6px] rounded-primary-radius border-[1px]",
          style: _normalizeStyle({
            borderColor: `${_unref(getTerminStatusBorder)(__props.termin.termin_status?.id)}`,
            backgroundColor: `${_unref(getTerminStatusColor)(
              __props.termin.termin_status?.id
            )}`,
          })
        }, _toDisplayString(__props.termin.termin_status ? __props.termin.termin_status?.name : "undefined"), 5)
      ]),
      _createElementVNode("div", null, [
        _createVNode(HeadBlocks, { termin: __props.termin }, null, 8, ["termin"])
      ]),
      (
          __props.termin.phase_progress?.phase.id === 2 ||
          __props.termin.phase_progress?.phase.id === 1
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-primary-text-color text-xl leading-[32px] font-semibold tracking-[0.01rem]" }, " Abnameprotokoll ", -1)),
                  (
                  abnahmeprotokollReportData.value &&
                  abnahmeprotokollReportData.value?.status
                )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(abnahmeprotokollReportData.value
                    ? _unref(getStatusByName)(abnahmeprotokollReportData.value?.status)
                    : ""), 1))
                    : _createCommentVNode("", true),
                  (abnahmeprotokollReportData.value?.pdf_stale)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, " PDF outdated "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (abnahmeprotokollReportData.value?.status !== 'signed')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = 
                  () => {
                    isSignedDocument.value = false;
                    isUpdateAbnahmeProtocolModal.value = true;
                  }
                )
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "Update"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (abnahmeprotokollReportData.value?.status !== 'signed')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: openAbnahmeprotokollModal
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "Edit icon"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (
                  abnahmeprotokollReportData.value?.status === 'signed' ||
                  abnahmeprotokollReportData.value?.pdf_stale
                )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: openAbnahmeprotokollModal,
                        title: "View / Force Regenerate"
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "View icon"
                        }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (abnahmeProtocolModalOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(AbnameProtocolModal, {
                      termin: __props.termin,
                      data: abnahmeprotokollReportData.value,
                      onClose: _cache[1] || (_cache[1] = ($event: any) => (abnahmeProtocolModalOpen.value = false)),
                      onRefresh: _cache[2] || (_cache[2] = 
                async () => {
                  await getAbnahmeprotokollReportData();
                }
              ),
                      onUploadSignedVersion: _cache[3] || (_cache[3] = 
                () => {
                  isSignedDocument.value = true;
                  abnahmeProtocolModalOpen.value = false;
                  isUpdateAbnahmeProtocolModal.value = true;
                }
              )
                    }, null, 8, ["termin", "data"])
                  ]))
                : _createCommentVNode("", true),
              (isUpdateAbnahmeProtocolModal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(UpdateAbnahmeProtocolModal, {
                      "is-signed-document": isSignedDocument.value,
                      termin: props.termin.id,
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (isUpdateAbnahmeProtocolModal.value = false)),
                      onRefresh: _cache[5] || (_cache[5] = 
                async () => {
                  await getAbnahmeprotokollReportData();
                }
              )
                    }, null, 8, ["is-signed-document", "termin"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                onClick: openPrufberichtModal,
                class: "flex items-center justify-between p-3 rounded-primary-radius bg-[#E5E4E2] cursor-pointer hover:bg-[#dfdedc] duration-500"
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-primary-text-color text-xl leading-[32px] font-semibold tracking-[0.01rem]" }, " Prüfbericht ", -1)),
                (prufberichtReportData.value?.status)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(prufberichtReportData.value
                  ? _unref(getStatusByName)(prufberichtReportData.value?.status)
                  : ""), 1))
                  : _createCommentVNode("", true)
              ]),
              (prufberichtModalOpen.value && prufberichtReportData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(PrufBerichtModal, {
                      termin: __props.termin,
                      data: prufberichtReportData.value,
                      onClose: _cache[6] || (_cache[6] = ($event: any) => (prufberichtModalOpen.value = false))
                    }, null, 8, ["termin", "data"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.termin.issues)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(IssuesBlock, {
              "is-issues-feature-flag-active": __props.isIssuesFeatureFlagActive,
              "issue-types": __props.termin.issueTypes?.map((item)=> {
            return {
              id: item.id,
              name: item.name
            }
          }),
              "issue-block-types": __props.termin.issueBlockTypes?.map((item)=> {
            return {
              id: item.id,
              name: item.name
            }
          }),
              issues: __props.termin.issues,
              termin: __props.termin.id,
              onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('refresh')))
            }, null, 8, ["is-issues-feature-flag-active", "issue-types", "issue-block-types", "issues", "termin"])
          ]))
        : _createCommentVNode("", true),
      (__props.termin.notes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(NoteBlock, {
              termin: __props.termin.id,
              onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('refresh'))),
              notes: __props.termin.notes
            }, null, 8, ["termin", "notes"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(MeisterNoteBlock, {
          termin: __props.termin.id,
          "meister-note": __props.termin.meisterNote,
          onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('refresh')))
        }, null, 8, ["termin", "meister-note"])
      ])
    ])
  ]))
}
}

})